// Calculs de l'horodateur (dates « AAAA-MM-JJ » et heures « HH:MM » locales).

const pad = (value) => String(value).padStart(2, '0');

export const BUSINESS_TIME_ZONE = 'America/Toronto';

// Heure du Québec (celle du serveur), quel que soit le fuseau de l'appareil :
// Date dont les champs locaux valent l'heure murale du Québec.
export const businessNow = (instant = new Date()) => {
  try {
    const parts = Object.fromEntries(
      new Intl.DateTimeFormat('en-CA', {
        timeZone: BUSINESS_TIME_ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
      }).formatToParts(instant).map((part) => [part.type, part.value])
    );
    return new Date(
      Number(parts.year), Number(parts.month) - 1, Number(parts.day),
      Number(parts.hour), Number(parts.minute), Number(parts.second)
    );
  } catch (error) {
    return instant;
  }
};

export const toDateKey = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const toTimeKey = (date) => `${pad(date.getHours())}:${pad(date.getMinutes())}`;

const minutesOf = (time) => {
  if (!time || !/^\d{1,2}:\d{2}$/.test(time)) return null;
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
};

export const isOpen = (entry) => !entry.end_time;

// Durée en minutes; un pointage en cours aujourd'hui compte jusqu'à maintenant.
export const entryMinutes = (entry, now = new Date()) => {
  const start = minutesOf(entry.start_time);
  if (start === null) return 0;
  let end = minutesOf(entry.end_time);
  if (end === null) {
    if (entry.date !== toDateKey(now)) return 0;
    end = now.getHours() * 60 + now.getMinutes();
  }
  return Math.max(0, end - start);
};

export const formatDuration = (minutes) => {
  const total = Math.max(0, Math.round(minutes));
  return `${Math.floor(total / 60)} h ${pad(total % 60)}`;
};

// Lundi de la semaine de « date ».
export const weekStart = (date = new Date()) => {
  const monday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const offset = (monday.getDay() + 6) % 7;
  monday.setDate(monday.getDate() - offset);
  return monday;
};

export const DAY_LABELS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

// Récapitulatif hebdomadaire d'une personne : minutes par jour et totaux.
export const weekSummary = (entries, employeeId, now = new Date(), offsetWeeks = 0) => {
  const monday = weekStart(now);
  monday.setDate(monday.getDate() + offsetWeeks * 7);
  const days = DAY_LABELS.map((label, index) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + index);
    return { label, date: toDateKey(day), minutes: 0 };
  });
  const byDate = Object.fromEntries(days.map((day) => [day.date, day]));
  let mileage = 0;
  let meals = 0;
  entries
    .filter((entry) => entry.employee_id === employeeId && byDate[entry.date])
    .forEach((entry) => {
      byDate[entry.date].minutes += entryMinutes(entry, now);
      mileage += Number(entry.mileage) || 0;
      meals += Number(entry.meal_expense) || 0;
    });
  return {
    days,
    from: days[0].date,
    to: days[6].date,
    minutes: days.reduce((sum, day) => sum + day.minutes, 0),
    mileage,
    meals,
  };
};

// Pointage ouvert de la personne (le plus récent).
export const openEntryOf = (entries, employeeId) =>
  entries.find((entry) => entry.employee_id === employeeId && isOpen(entry)) || null;
